<template>
  <div dir="rtl" class="mr-8 px-4 sm:px-6 lg:px-8">
    <div class="sm:flex sm:items-center sm:justify-between">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">{{ scope === 'day' ? 'جلسات اليوم' : 'الجلسات الحالية' }}</h1>
        <p class="mt-2 text-sm text-gray-700">
          {{ scope === 'day'
            ? 'هذه القائمة تعرض جميع جلسات اليوم (سواء بدأت أم لم تبدأ).'
            : 'هذه القائمة تعرض الجلسات التي وقتها الآن (حسب نافذة الوقت) حتى لو لم يدخل عليها أحد.' }}
        </p>
      </div>
      <div class="mt-4 sm:mt-0">
        <button @click="load" class="button" :disabled="loading">
          {{ loading ? 'جاري التحديث...' : 'تحديث' }}
        </button>
      </div>
    </div>

    <div class="mt-6">
      <div class="flex flex-col sm:flex-row gap-3 items-start sm:items-center">
        <input
          v-model="search"
          type="text"
          placeholder="بحث بـ channel_name أو الاسم"
          class="w-full sm:w-96 border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <select
          v-model="filterType"
          class="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <option value="">كل الأنواع</option>
          <option value="STUDENT_TEACHER">جلسة (دارس/معلم)</option>
          <option value="ALTERNATIVE">جلسة بديلة</option>
          <option value="MUDARASA">مدارسة</option>
          <option value="PEER_REVIEW">تعاهد</option>
          <option value="PUBLIC_CIRCLE">الحلقات العامة</option>
          <option value="IQRA">اقرأ</option>
        </select>
        <select
          v-model="scope"
          class="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          @change="load"
        >
          <option value="day">اليوم</option>
          <option value="now">الآن</option>
        </select>
      </div>
    </div>

    <div class="mt-6">
      <div class="bg-white shadow rounded-lg overflow-hidden">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">النوع</th>
                <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">الحالة</th>
                <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">الوقت</th>
                <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">الدارس</th>
                <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">المعلم/الشريك</th>
                <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">آخر نبضة</th>
                <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">connection_state</th>
                <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">إجراءات</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-if="!loading && filtered.length === 0">
                <td class="px-4 py-6 text-center text-sm text-gray-500" colspan="9">
                  لا توجد جلسات في الوقت الحالي
                </td>
              </tr>
              <tr v-for="row in filtered" :key="rowKey(row)">
                <td class="px-4 py-3 text-sm text-gray-900">
                  {{ typeLabel(row.session_type) }}
                </td>
                <td class="px-4 py-3 text-sm">
                  <span
                    :class="statusClass(row)"
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                  >
                    {{ statusLabel(row) }}
                  </span>
                </td>
                <td class="px-4 py-3 text-sm text-gray-700">
                  <div>{{ row.session_date }}</div>
                  <div class="text-xs text-gray-500">{{ row.time_from }} - {{ row.time_to }}</div>
                </td>
                <td class="px-4 py-3 text-sm text-gray-900">
                  {{ row.student_name || '-' }}
                </td>
                <td class="px-4 py-3 text-sm text-gray-900">
                  {{ row.teacher_name || '-' }}
                </td>
                <td class="px-4 py-3 text-sm text-gray-700">
                  {{ row.last_heartbeat || '-' }}
                </td>
                <td class="px-4 py-3 text-sm text-gray-700">
                  {{ row.connection_state || '-' }}
                </td>
                <td class="px-4 py-3 text-sm">
                  <div class="flex flex-col sm:flex-row gap-2">
                    <button
                      class="px-3 py-1 rounded-md text-xs font-medium bg-gray-900 text-white hover:bg-gray-800 disabled:opacity-50"
                      :disabled="player.loading"
                      @click="openPlayer(row, 'STEALTH_LISTEN')"
                    >
                      استماع فقط
                    </button>
                    <button
                      class="px-3 py-1 rounded-md text-xs font-medium bg-primary text-white hover:opacity-90 disabled:opacity-50"
                      :disabled="player.loading"
                      @click="openPlayer(row, 'FULL_JOIN')"
                    >
                      دخول كامل
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Player Modal -->
    <div v-if="player.open" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="fixed inset-0 bg-black bg-opacity-50" @click="closePlayer"></div>
      <div class="relative bg-white w-full max-w-xl mx-4 rounded-lg shadow-xl overflow-hidden">
        <div class="flex items-center justify-between px-4 py-3 border-b">
          <div>
            <div class="text-sm font-semibold text-gray-900">التحكم بالصوت</div>
            <div class="text-xs text-gray-500 font-mono">{{ player.channelName }}</div>
          </div>
          <button class="text-gray-500 hover:text-gray-700" @click="closePlayer">✕</button>
        </div>

        <div class="p-4 space-y-3">
          <div class="flex items-center gap-2">
            <span
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
              :class="player.connected ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'"
            >
              {{ player.connected ? 'متصل' : (player.loading ? 'جاري الاتصال...' : 'غير متصل') }}
            </span>
            <span class="text-xs text-gray-600">
              الوضع: {{ player.mode === 'STEALTH_LISTEN' ? 'استماع سري' : 'دخول كامل' }}
            </span>
          </div>

          <div v-if="player.error" class="text-sm text-red-600">
            {{ player.error }}
          </div>

          <div class="flex flex-wrap gap-2">
            <button
              class="px-3 py-2 rounded-md text-sm font-medium bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
              :disabled="player.loading"
              @click="reconnect"
            >
              إعادة اتصال
            </button>

            <button
              v-if="player.mode === 'FULL_JOIN'"
              class="px-3 py-2 rounded-md text-sm font-medium"
              :class="player.micOn ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-green-600 text-white hover:bg-green-700'"
              :disabled="!player.connected || player.loading"
              @click="toggleMic"
            >
              {{ player.micOn ? 'إيقاف المايك' : 'تشغيل المايك' }}
            </button>

            <button
              class="px-3 py-2 rounded-md text-sm font-medium bg-gray-900 text-white hover:bg-gray-800 disabled:opacity-50"
              :disabled="player.loading"
              @click="closePlayer"
            >
              إنهاء
            </button>
          </div>

          <div class="text-xs text-gray-500">
            ملاحظة: هذه الصفحة تستخدم Agora Web SDK عبر CDN. يجب توفر اتصال بالإنترنت في بيئة النشر.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { getLiveSessions, joinLiveSession, leaveLiveSession } from '../services/liveSessions';

export default {
  name: 'LiveSessions',
  setup() {
    const loading = ref(false);
    const rows = ref([]);
    const search = ref('');
    const filterType = ref('');
    const scope = ref('day');

    // Agora player state (audio only)
    const player = ref({
      open: false,
      loading: false,
      connected: false,
      error: '',
      mode: null,
      joinId: null,
      sessionType: null,
      trackerId: null,
      channelName: '',
      micOn: false,
      // runtime objects
      _client: null,
      _localTrack: null,
      _agora: null,
    });

    const load = async () => {
      loading.value = true;
      try {
        const data = await getLiveSessions({ scope: scope.value });
        rows.value = Array.isArray(data) ? data : [];
      } catch (e) {
        console.error('Failed to load live sessions:', e);
        alert('حدث خطأ أثناء جلب الجلسات الحالية');
      } finally {
        loading.value = false;
      }
    };

    const rowKey = (r) => `${r.session_type}-${r.tracker_id || r.session_id}-${r.channel_name}`;

    const typeLabel = (t) => {
      switch (t) {
        case 'STUDENT_TEACHER': return 'دارس/معلم';
        case 'ALTERNATIVE': return 'جلسة بديلة';
        case 'MUDARASA': return 'مدارسة';
        case 'PEER_REVIEW': return 'تعاهد';
        case 'PUBLIC_CIRCLE': return 'الحلقات العامة';
        case 'IQRA': return 'اقرأ';
        default: return t || '-';
      }
    };

    const filtered = computed(() => {
      const q = (search.value || '').trim().toLowerCase();
      return rows.value.filter(r => {
        if (filterType.value && r.session_type !== filterType.value) return false;
        if (!q) return true;
        const hay = [
          r.channel_name,
          r.student_name,
          r.teacher_name,
          r.session_type,
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        return hay.includes(q);
      });
    });

    const statusLabel = (row) => {
      if (row?.is_connected) return 'متصل';
      if (row?.time_state === 'UPCOMING') return 'لم تبدأ بعد';
      if (row?.time_state === 'ENDED') return 'انتهت';
      return 'ضمن الوقت (بدون اتصال)';
    };

    const statusClass = (row) => {
      if (row?.is_connected) return 'bg-green-100 text-green-800';
      if (row?.time_state === 'UPCOMING') return 'bg-blue-100 text-blue-800';
      if (row?.time_state === 'ENDED') return 'bg-gray-100 text-gray-800';
      return 'bg-yellow-100 text-yellow-800';
    };

    onMounted(load);

    const loadAgoraSdk = () => {
      if (window.AgoraRTC) return Promise.resolve(window.AgoraRTC);
      if (window.__agoraSdkLoadingPromise) return window.__agoraSdkLoadingPromise;

      window.__agoraSdkLoadingPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://download.agora.io/sdk/release/AgoraRTC_N-4.22.2.js';
        script.async = true;
        script.onload = () => resolve(window.AgoraRTC);
        script.onerror = () => reject(new Error('Failed to load Agora SDK'));
        document.head.appendChild(script);
      });

      return window.__agoraSdkLoadingPromise;
    };

    const cleanupAgora = async () => {
      try {
        if (player.value._localTrack) {
          try { await player.value._client?.unpublish(player.value._localTrack); } catch (_) { /* ignore */ }
          try { player.value._localTrack.stop(); } catch (_) { /* ignore */ }
          try { player.value._localTrack.close(); } catch (_) { /* ignore */ }
        }
        if (player.value._client) {
          try { await player.value._client.leave(); } catch (_) { /* ignore */ }
        }
      } finally {
        player.value._localTrack = null;
        player.value._client = null;
        player.value.connected = false;
        player.value.micOn = false;
      }
    };

    const connectAgora = async () => {
      player.value.loading = true;
      player.value.error = '';
      try {
        const agora = await loadAgoraSdk();
        player.value._agora = agora;

        const joinInfo = await joinLiveSession({
          sessionType: player.value.sessionType,
          trackerId: player.value.trackerId,
          mode: player.value.mode,
        });

        const appId = String(joinInfo?.appId || '').trim();
        const channelName = String(joinInfo?.channelName || '').trim();
        const token = String(joinInfo?.token || '');
        const uid = Number(joinInfo?.uid);

        // Basic validation before calling Agora SDK (helps debugging misconfig quickly)
        if (!appId || appId.length !== 32) {
          throw new Error(`Agora appId غير صالح (len=${appId.length || 0})`);
        }
        if (!channelName) {
          throw new Error('Agora channelName غير صالح');
        }
        if (!token || token.length < 50) {
          throw new Error(`Agora token غير صالح (len=${token.length || 0})`);
        }
        if (!Number.isFinite(uid) || uid <= 0) {
          throw new Error(`Agora uid غير صالح (${joinInfo?.uid})`);
        }

        console.info('[LiveSessions Agora] join payload', {
          mode: player.value.mode,
          sessionType: player.value.sessionType,
          trackerId: player.value.trackerId,
          appIdLast4: appId.slice(-4),
          channelName,
          tokenLen: token.length,
          uid,
        });

        player.value.joinId = joinInfo.joinId || null;
        player.value.channelName = channelName;

        const client = agora.createClient({ mode: 'live', codec: 'vp8' });
        player.value._client = client;

        client.on('user-published', async (remoteUser, mediaType) => {
          try {
            await client.subscribe(remoteUser, mediaType);
            if (mediaType === 'audio' && remoteUser.audioTrack) {
              remoteUser.audioTrack.play();
            }
          } catch (e) {
            console.warn('Subscribe failed:', e);
          }
        });

        client.on('user-unpublished', (remoteUser, mediaType) => {
          if (mediaType === 'audio' && remoteUser.audioTrack) {
            try { remoteUser.audioTrack.stop(); } catch (_) { /* ignore */ }
          }
        });

        if (player.value.mode === 'STEALTH_LISTEN') {
          await client.setClientRole('audience');
        } else {
          // Full join as host (audio only). Mic is OFF by default.
          await client.setClientRole('host');
        }

        await client.join(appId, channelName, token, uid);
        player.value.connected = true;
      } catch (e) {
        console.error('Agora connect error:', e);
        player.value.error = e?.message || 'فشل الاتصال';
        await cleanupAgora();
      } finally {
        player.value.loading = false;
      }
    };

    const openPlayer = async (row, mode) => {
      player.value.open = true;
      player.value.mode = mode;
      player.value.sessionType = row.session_type;
      player.value.trackerId = row.tracker_id;
      player.value.channelName = row.channel_name || '';
      await connectAgora();
    };

    const closePlayer = async () => {
      player.value.loading = true;
      try {
        await cleanupAgora();
        if (player.value.joinId) {
          await leaveLiveSession({ joinId: player.value.joinId });
        }
      } finally {
        player.value.open = false;
        player.value.loading = false;
        player.value.error = '';
        player.value.joinId = null;
        player.value.sessionType = null;
        player.value.trackerId = null;
        player.value.channelName = '';
      }
    };

    const toggleMic = async () => {
      if (player.value.mode !== 'FULL_JOIN') return;
      if (!player.value.connected || !player.value._client || !player.value._agora) return;
      player.value.loading = true;
      player.value.error = '';
      try {
        if (!player.value.micOn) {
          const track = await player.value._agora.createMicrophoneAudioTrack();
          player.value._localTrack = track;
          await player.value._client.publish(track);
          player.value.micOn = true;
        } else {
          if (player.value._localTrack) {
            await player.value._client.unpublish(player.value._localTrack);
            player.value._localTrack.stop();
            player.value._localTrack.close();
            player.value._localTrack = null;
          }
          player.value.micOn = false;
        }
      } catch (e) {
        console.error('Mic toggle error:', e);
        player.value.error = e?.message || 'فشل تشغيل/إيقاف المايك';
      } finally {
        player.value.loading = false;
      }
    };

    const reconnect = async () => {
      await cleanupAgora();
      await connectAgora();
    };

    return {
      loading,
      rows,
      search,
      filterType,
      scope,
      filtered,
      load,
      rowKey,
      typeLabel,
      statusLabel,
      statusClass,
      player,
      openPlayer,
      closePlayer,
      toggleMic,
      reconnect,
    };
  },
};
</script>


